import { t as e } from "./utils-DiFe-_ei.js";
import { t } from "./dist-DAt3we1k.js";
import * as n from "react";
import { Fragment as r, jsx as i, jsxs as a } from "react/jsx-runtime";
import * as o from "react-dom";
//#region ../../node_modules/.pnpm/@radix-ui+number@1.1.3/node_modules/@radix-ui/number/dist/index.mjs
var s = Object.defineProperty, c = (e, t) => s(e, "name", {
	value: t,
	configurable: !0
});
function l(e, [t, n]) {
	return Math.min(n, Math.max(t, e));
}
c(l, "clamp");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-compose-refs@1.1.4_@types+react@19.2.17_react@19.2.7/node_modules/@radix-ui/react-compose-refs/dist/index.mjs
var u = Object.defineProperty, d = (e, t) => u(e, "name", {
	value: t,
	configurable: !0
});
function f(e, t) {
	if (typeof e == "function") return e(t);
	e != null && (e.current = t);
}
d(f, "setRef");
function p(...e) {
	return (t) => {
		let n = !1, r = e.map((e) => {
			let r = f(e, t);
			return !n && typeof r == "function" && (n = !0), r;
		});
		if (n) return () => {
			for (let t = 0; t < r.length; t++) {
				let n = r[t];
				typeof n == "function" ? n() : f(e[t], null);
			}
		};
	};
}
d(p, "composeRefs");
function m(...e) {
	return n.useCallback(p(...e), e);
}
d(m, "useComposedRefs");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-context@1.2.1_@types+react@19.2.17_react@19.2.7/node_modules/@radix-ui/react-context/dist/index.mjs
var h = Object.defineProperty, g = (e, t) => h(e, "name", {
	value: t,
	configurable: !0
});
// @__NO_SIDE_EFFECTS__
function _(e, t) {
	let r = n.createContext(t);
	r.displayName = e + "Context";
	let a = /* @__PURE__ */ g((e) => {
		let { children: t, ...a } = e, o = n.useMemo(() => a, Object.values(a));
		return /* @__PURE__ */ i(r.Provider, {
			value: o,
			children: t
		});
	}, "Provider");
	a.displayName = e + "Provider";
	function o(i, a = {}) {
		let { optional: o = !1 } = a, s = n.useContext(r);
		if (s) return s;
		if (t !== void 0) return t;
		if (!o) throw Error(`\`${i}\` must be used within \`${e}\``);
	}
	return g(o, "useContext"), [a, o];
}
g(_, "createContext");
// @__NO_SIDE_EFFECTS__
function v(e, t = []) {
	let r = [];
	function a(t, a) {
		let o = n.createContext(a);
		o.displayName = t + "Context";
		let s = r.length;
		r = [...r, a];
		let c = /* @__PURE__ */ g((t) => {
			let { scope: r, children: a, ...c } = t, l = r?.[e]?.[s] || o, u = n.useMemo(() => c, Object.values(c));
			return /* @__PURE__ */ i(l.Provider, {
				value: u,
				children: a
			});
		}, "Provider");
		c.displayName = t + "Provider";
		function l(r, i, c = {}) {
			let { optional: l = !1 } = c, u = i?.[e]?.[s] || o, d = n.useContext(u);
			if (d) return d;
			if (a !== void 0) return a;
			if (!l) throw Error(`\`${r}\` must be used within \`${t}\``);
		}
		return g(l, "useContext"), [c, l];
	}
	g(a, "createContext");
	let o = /* @__PURE__ */ g(() => {
		let t = r.map((e) => n.createContext(e));
		return /* @__PURE__ */ g(function(r) {
			let i = r?.[e] || t;
			return n.useMemo(() => ({ [`__scope${e}`]: {
				...r,
				[e]: i
			} }), [r, i]);
		}, "useScope");
	}, "createScope");
	return o.scopeName = e, [a, y(o, ...t)];
}
g(v, "createContextScope");
function y(...e) {
	let t = e[0];
	if (e.length === 1) return t;
	let r = /* @__PURE__ */ g(() => {
		let r = e.map((e) => ({
			useScope: e(),
			scopeName: e.scopeName
		}));
		return /* @__PURE__ */ g(function(e) {
			let i = r.reduce((t, { useScope: n, scopeName: r }) => {
				let i = n(e)[`__scope${r}`];
				return {
					...t,
					...i
				};
			}, {});
			return n.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
		}, "useComposedScopes");
	}, "createScope");
	return r.scopeName = t.scopeName, r;
}
g(y, "composeContextScopes");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-use-layout-effect@1.1.3_@types+react@19.2.17_react@19.2.7/node_modules/@radix-ui/react-use-layout-effect/dist/index.mjs
var b = globalThis?.document ? n.useLayoutEffect : () => {}, x = Object.defineProperty, ee = (e, t) => x(e, "name", {
	value: t,
	configurable: !0
}), S = n.useEffectEvent, C = n.useInsertionEffect;
function w(e) {
	if (typeof S == "function") return S(e);
	let t = n.useRef(() => {
		throw Error("Cannot call an event handler while rendering.");
	});
	return typeof C == "function" ? C(() => {
		t.current = e;
	}) : b(() => {
		t.current = e;
	}), n.useMemo(() => ((...e) => t.current?.(...e)), []);
}
ee(w, "useEffectEvent");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-use-controllable-state@1.2.5_@types+react@19.2.17_react@19.2.7/node_modules/@radix-ui/react-use-controllable-state/dist/index.mjs
var T = Object.defineProperty, E = (e, t) => T(e, "name", {
	value: t,
	configurable: !0
}), te = n.useInsertionEffect || b;
function ne({ prop: e, defaultProp: t, onChange: r = /* @__PURE__ */ E(() => {}, "onChange"), caller: i }) {
	let [a, o, s] = D({
		defaultProp: t,
		onChange: r
	}), c = e !== void 0;
	return [c ? e : a, n.useCallback((t) => {
		if (c) {
			let n = O(t) ? t(e) : t;
			n !== e && s.current?.(n);
		} else o(t);
	}, [
		c,
		e,
		o,
		s
	])];
}
E(ne, "useControllableState");
function D({ defaultProp: e, onChange: t }) {
	let [r, i] = n.useState(e), a = n.useRef(r), o = n.useRef(t);
	return te(() => {
		o.current = t;
	}, [t]), n.useEffect(() => {
		a.current !== r && (o.current?.(r), a.current = r);
	}, [r, a]), [
		r,
		i,
		o
	];
}
E(D, "useUncontrolledState");
function O(e) {
	return typeof e == "function";
}
E(O, "isFunction");
var k = Symbol("RADIX:SYNC_STATE");
function re(e, t, r, i) {
	let { prop: a, defaultProp: o, onChange: s, caller: c } = t, l = a !== void 0, u = w(s), d = [{
		...r,
		state: o
	}];
	i && d.push(i);
	let [f, p] = n.useReducer((t, n) => {
		if (n.type === k) return {
			...t,
			state: n.state
		};
		let r = e(t, n);
		return l && !Object.is(r.state, t.state) && u(r.state), r;
	}, ...d), m = f.state, h = n.useRef(m);
	n.useEffect(() => {
		h.current !== m && (h.current = m, l || u(m));
	}, [
		m,
		h,
		l
	]);
	let g = n.useMemo(() => a === void 0 ? f : {
		...f,
		state: a
	}, [f, a]);
	return n.useEffect(() => {
		l && !Object.is(a, f.state) && p({
			type: k,
			state: a
		});
	}, [
		a,
		f.state,
		l
	]), [g, p];
}
E(re, "useControllableStateReducer");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-direction@1.1.3_@types+react@19.2.17_react@19.2.7/node_modules/@radix-ui/react-direction/dist/index.mjs
var A = Object.defineProperty, j = (e, t) => A(e, "name", {
	value: t,
	configurable: !0
}), M = n.createContext(void 0);
function N(e) {
	let t = n.useContext(M);
	return e || t || "ltr";
}
j(N, "useDirection");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-use-previous@1.1.3_@types+react@19.2.17_react@19.2.7/node_modules/@radix-ui/react-use-previous/dist/index.mjs
var ie = Object.defineProperty, ae = (e, t) => ie(e, "name", {
	value: t,
	configurable: !0
});
function oe(e) {
	let t = n.useRef({
		value: e,
		previous: e
	});
	return n.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
ae(oe, "usePrevious");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-use-size@1.1.3_@types+react@19.2.17_react@19.2.7/node_modules/@radix-ui/react-use-size/dist/index.mjs
var se = Object.defineProperty, ce = (e, t) => se(e, "name", {
	value: t,
	configurable: !0
});
function le(e) {
	let [t, r] = n.useState(void 0);
	return b(() => {
		if (e) {
			r({
				width: e.offsetWidth,
				height: e.offsetHeight
			});
			let t = new ResizeObserver((t) => {
				if (!Array.isArray(t) || !t.length) return;
				let n = t[0], i, a;
				if ("borderBoxSize" in n) {
					let e = n.borderBoxSize, t = Array.isArray(e) ? e[0] : e;
					i = t.inlineSize, a = t.blockSize;
				} else i = e.offsetWidth, a = e.offsetHeight;
				r({
					width: i,
					height: a
				});
			});
			return t.observe(e, { box: "border-box" }), () => t.unobserve(e);
		} else r(void 0);
	}, [e]), t;
}
ce(le, "useSize");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-slot@1.3.1_@types+react@19.2.17_react@19.2.7/node_modules/@radix-ui/react-slot/dist/index.mjs
var ue = Object.defineProperty, P = (e, t) => ue(e, "name", {
	value: t,
	configurable: !0
}), de = /* @__PURE__ */ P(((e, t) => {
	let n = { ...t };
	for (let r in t) {
		let i = e[r], a = t[r];
		if (/^on[A-Z]/.test(r)) if (i && a) {
			let e = typeof i == "function", t = typeof a == "function";
			n[r] = (...n) => {
				let r = t ? a(...n) : void 0;
				return e && i(...n), r;
			};
		} else i && (n[r] = i);
		else r === "style" ? n[r] = {
			...typeof i == "object" ? i : null,
			...typeof a == "object" ? a : null
		} : r === "className" ? n[r] = [i, a].filter(Boolean).join(" ") : r === "aria-describedby" && (n[r] = fe(a, i));
	}
	return {
		...e,
		...n
	};
}), "mergeProps");
function fe(...e) {
	let t = /* @__PURE__ */ new Set();
	for (let n of e) if (typeof n == "string") for (let e of String(n).trim().split(/\s+/)) e && t.add(e);
	return t.size > 0 ? Array.from(t).join(" ") : void 0;
}
P(fe, "concatAriaDescribedby");
var pe = n.createContext(de);
pe.displayName = "SlotContext";
// @__NO_SIDE_EFFECTS__
function F(e) {
	let t = n.forwardRef((t, r) => {
		let i = n.useContext(pe), { children: a, mergeProps: o = i, ...s } = t, c = null, l = !1, u = [];
		I(a) && typeof L == "function" && (a = L(a._payload)), n.Children.forEach(a, (e) => {
			if (ve(e)) {
				l = !0;
				let t = e, n = "child" in t.props ? t.props.child : t.props.children;
				I(n) && typeof L == "function" && (n = L(n._payload)), c = ge(t, n), u.push(c?.props?.children);
			} else u.push(e);
		}), c ? c = n.cloneElement(c, void 0, u) : !l && n.Children.count(a) === 1 && n.isValidElement(a) && (c = a);
		let d = c ? _e(c) : void 0, f = m(r, d);
		if (!c) {
			if (a || a === 0) throw Error(l ? Se(e) : xe(e));
			return a;
		}
		let p = o(s, c.props ?? {});
		return c.type !== n.Fragment && (p.ref = r ? f : d), n.cloneElement(c, p);
	});
	return t.displayName = `${e}.Slot`, t;
}
P(F, "createSlot");
var me = Symbol.for("radix.slottable");
// @__NO_SIDE_EFFECTS__
function he(e) {
	let t = /* @__PURE__ */ P((e) => "child" in e ? e.children(e.child) : e.children, "Slottable");
	return t.displayName = `${e}.Slottable`, t.__radixId = me, t;
}
P(he, "createSlottable");
var ge = /* @__PURE__ */ P((e, t) => {
	if ("child" in e.props) {
		let t = e.props.child;
		return n.isValidElement(t) ? n.cloneElement(t, void 0, e.props.children(t.props.children)) : null;
	}
	return n.isValidElement(t) ? t : null;
}, "getSlottableElementFromSlottable");
function _e(e) {
	let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
	return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
P(_e, "getElementRef");
function ve(e) {
	return n.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === me;
}
P(ve, "isSlottable");
var ye = Symbol.for("react.lazy");
function I(e) {
	return typeof e == "object" && !!e && "$$typeof" in e && e.$$typeof === ye && "_payload" in e && be(e._payload);
}
P(I, "isLazyComponent");
function be(e) {
	return typeof e == "object" && !!e && "then" in e;
}
P(be, "isPromiseLike");
var xe = /* @__PURE__ */ P((e) => `${e} failed to slot onto its children. Expected a single React element child or \`Slottable\`.`, "createSlotError"), Se = /* @__PURE__ */ P((e) => `${e} failed to slot onto its \`Slottable\`. Expected \`Slottable\` to receive a single React element child.`, "createSlottableError"), L = n.use, Ce = Object.defineProperty, we = (e, t) => Ce(e, "name", {
	value: t,
	configurable: !0
}), R = [
	"a",
	"button",
	"div",
	"form",
	"h2",
	"h3",
	"img",
	"input",
	"label",
	"li",
	"nav",
	"ol",
	"p",
	"select",
	"span",
	"svg",
	"ul"
].reduce((e, t) => {
	let r = /* @__PURE__ */ F(`Primitive.${t}`), a = n.forwardRef((e, n) => {
		let { asChild: a, ...o } = e, s = a ? r : t;
		return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ i(s, {
			...o,
			ref: n
		});
	});
	return a.displayName = `Primitive.${t}`, {
		...e,
		[t]: a
	};
}, {});
function Te(e, t) {
	e && o.flushSync(() => e.dispatchEvent(t));
}
we(Te, "dispatchDiscreteCustomEvent");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-collection@1.1.13_@types+react-dom@19.2.3_@types+react@19.2.17__@types+_1b4199653af51cc72123e3ada1874722/node_modules/@radix-ui/react-collection/dist/index.mjs
var Ee = Object.defineProperty, z = (e, t) => Ee(e, "name", {
	value: t,
	configurable: !0
});
// @__NO_SIDE_EFFECTS__
function De(e) {
	let t = e + "CollectionProvider", [r, a] = /* @__PURE__ */ v(t), [o, s] = r(t, {
		collectionRef: { current: null },
		itemMap: /* @__PURE__ */ new Map()
	}), c = /* @__PURE__ */ z((e) => {
		let { scope: t, children: r } = e, a = n.useRef(null), s = n.useRef(/* @__PURE__ */ new Map()).current;
		return /* @__PURE__ */ i(o, {
			scope: t,
			itemMap: s,
			collectionRef: a,
			children: r
		});
	}, "CollectionProvider");
	c.displayName = t;
	let l = e + "CollectionSlot", u = /* @__PURE__ */ F(l), d = n.forwardRef((e, t) => {
		let { scope: n, children: r } = e, a = m(t, s(l, n).collectionRef);
		return /* @__PURE__ */ i(u, {
			ref: a,
			children: r
		});
	});
	d.displayName = l;
	let f = e + "CollectionItemSlot", p = "data-radix-collection-item", h = /* @__PURE__ */ F(f), g = n.forwardRef((e, t) => {
		let { scope: r, children: a, ...o } = e, c = n.useRef(null), l = m(t, c), u = s(f, r);
		return n.useEffect(() => (u.itemMap.set(c, {
			ref: c,
			...o
		}), () => void u.itemMap.delete(c))), /* @__PURE__ */ i(h, {
			[p]: "",
			ref: l,
			children: a
		});
	});
	g.displayName = f;
	function _(t) {
		let r = s(e + "CollectionConsumer", t);
		return n.useCallback(() => {
			let e = r.collectionRef.current;
			if (!e) return [];
			let t = Array.from(e.querySelectorAll(`[${p}]`));
			return Array.from(r.itemMap.values()).sort((e, n) => t.indexOf(e.ref.current) - t.indexOf(n.ref.current));
		}, [r.collectionRef, r.itemMap]);
	}
	return z(_, "useCollection"), [
		{
			Provider: c,
			Slot: d,
			ItemSlot: g
		},
		_,
		a
	];
}
z(De, "createCollection");
var Oe = /* @__PURE__ */ new WeakMap(), B = class e extends Map {
	static {
		z(this, "OrderedDict");
	}
	#e;
	constructor(e) {
		super(e), this.#e = [...super.keys()], Oe.set(this, !0);
	}
	set(e, t) {
		return Oe.get(this) && (this.has(e) ? this.#e[this.#e.indexOf(e)] = e : this.#e.push(e)), super.set(e, t), this;
	}
	insert(e, t, n) {
		let r = this.has(t), i = this.#e.length, a = H(e), o = a >= 0 ? a : i + a, s = o < 0 || o >= i ? -1 : o;
		if (s === this.size || r && s === this.size - 1 || s === -1) return this.set(t, n), this;
		let c = this.size + +!r;
		a < 0 && o++;
		let l = [...this.#e], u, d = !1;
		for (let e = o; e < c; e++) if (o === e) {
			let i = l[e];
			l[e] === t && (i = l[e + 1]), r && this.delete(t), u = this.get(i), this.set(t, n);
		} else {
			!d && l[e - 1] === t && (d = !0);
			let n = l[d ? e : e - 1], r = u;
			u = this.get(n), this.delete(n), this.set(n, r);
		}
		return this;
	}
	with(t, n, r) {
		let i = new e(this);
		return i.insert(t, n, r), i;
	}
	before(e) {
		let t = this.#e.indexOf(e) - 1;
		if (!(t < 0)) return this.entryAt(t);
	}
	setBefore(e, t, n) {
		let r = this.#e.indexOf(e);
		return r === -1 ? this : this.insert(r, t, n);
	}
	after(e) {
		let t = this.#e.indexOf(e);
		if (t = t === -1 || t === this.size - 1 ? -1 : t + 1, t !== -1) return this.entryAt(t);
	}
	setAfter(e, t, n) {
		let r = this.#e.indexOf(e);
		return r === -1 ? this : this.insert(r + 1, t, n);
	}
	first() {
		return this.entryAt(0);
	}
	last() {
		return this.entryAt(-1);
	}
	clear() {
		return this.#e = [], super.clear();
	}
	delete(e) {
		let t = super.delete(e);
		return t && this.#e.splice(this.#e.indexOf(e), 1), t;
	}
	deleteAt(e) {
		let t = this.keyAt(e);
		return t !== void 0 && this.delete(t);
	}
	at(e) {
		let t = V(this.#e, e);
		if (t !== void 0) return this.get(t);
	}
	entryAt(e) {
		let t = V(this.#e, e);
		if (t !== void 0) return [t, this.get(t)];
	}
	indexOf(e) {
		return this.#e.indexOf(e);
	}
	keyAt(e) {
		return V(this.#e, e);
	}
	from(e, t) {
		let n = this.indexOf(e);
		if (n === -1) return;
		let r = n + t;
		return r < 0 && (r = 0), r >= this.size && (r = this.size - 1), this.at(r);
	}
	keyFrom(e, t) {
		let n = this.indexOf(e);
		if (n === -1) return;
		let r = n + t;
		return r < 0 && (r = 0), r >= this.size && (r = this.size - 1), this.keyAt(r);
	}
	find(e, t) {
		let n = 0;
		for (let r of this) {
			if (Reflect.apply(e, t, [
				r,
				n,
				this
			])) return r;
			n++;
		}
	}
	findIndex(e, t) {
		let n = 0;
		for (let r of this) {
			if (Reflect.apply(e, t, [
				r,
				n,
				this
			])) return n;
			n++;
		}
		return -1;
	}
	filter(t, n) {
		let r = [], i = 0;
		for (let e of this) Reflect.apply(t, n, [
			e,
			i,
			this
		]) && r.push(e), i++;
		return new e(r);
	}
	map(t, n) {
		let r = [], i = 0;
		for (let e of this) r.push([e[0], Reflect.apply(t, n, [
			e,
			i,
			this
		])]), i++;
		return new e(r);
	}
	reduce(...e) {
		let [t, n] = e, r = 0, i = n ?? this.at(0);
		for (let n of this) i = r === 0 && e.length === 1 ? n : Reflect.apply(t, this, [
			i,
			n,
			r,
			this
		]), r++;
		return i;
	}
	reduceRight(...e) {
		let [t, n] = e, r = n ?? this.at(-1);
		for (let n = this.size - 1; n >= 0; n--) {
			let i = this.at(n);
			r = n === this.size - 1 && e.length === 1 ? i : Reflect.apply(t, this, [
				r,
				i,
				n,
				this
			]);
		}
		return r;
	}
	toSorted(t) {
		let n = [...this.entries()].sort(t);
		return new e(n);
	}
	toReversed() {
		let t = new e();
		for (let e = this.size - 1; e >= 0; e--) {
			let n = this.keyAt(e), r = this.get(n);
			t.set(n, r);
		}
		return t;
	}
	toSpliced(...t) {
		let n = [...this.entries()];
		return n.splice(...t), new e(n);
	}
	slice(t, n) {
		let r = new e(), i = this.size - 1;
		if (t === void 0) return r;
		t < 0 && (t += this.size), n !== void 0 && n > 0 && (i = n - 1);
		for (let e = t; e <= i; e++) {
			let t = this.keyAt(e), n = this.get(t);
			r.set(t, n);
		}
		return r;
	}
	every(e, t) {
		let n = 0;
		for (let r of this) {
			if (!Reflect.apply(e, t, [
				r,
				n,
				this
			])) return !1;
			n++;
		}
		return !0;
	}
	some(e, t) {
		let n = 0;
		for (let r of this) {
			if (Reflect.apply(e, t, [
				r,
				n,
				this
			])) return !0;
			n++;
		}
		return !1;
	}
};
function V(e, t) {
	if ("at" in Array.prototype) return Array.prototype.at.call(e, t);
	let n = ke(e, t);
	return n === -1 ? void 0 : e[n];
}
z(V, "at");
function ke(e, t) {
	let n = e.length, r = H(t), i = r >= 0 ? r : n + r;
	return i < 0 || i >= n ? -1 : i;
}
z(ke, "toSafeIndex");
function H(e) {
	return e !== e || e === 0 ? 0 : Math.trunc(e);
}
z(H, "toSafeInteger");
// @__NO_SIDE_EFFECTS__
function Ae(e) {
	let t = e + "CollectionProvider", [r, a] = /* @__PURE__ */ v(t), [o, s] = r(t, {
		collectionElement: null,
		collectionRef: { current: null },
		collectionRefObject: { current: null },
		itemMap: new B(),
		setItemMap: /* @__PURE__ */ z(() => void 0, "setItemMap")
	}), c = /* @__PURE__ */ z(({ state: e, ...t }) => e ? /* @__PURE__ */ i(u, {
		...t,
		state: e
	}) : /* @__PURE__ */ i(l, { ...t }), "CollectionProvider");
	c.displayName = t;
	let l = /* @__PURE__ */ z((e) => {
		let t = y();
		return /* @__PURE__ */ i(u, {
			...e,
			state: t
		});
	}, "CollectionInit");
	l.displayName = t + "Init";
	let u = /* @__PURE__ */ z((e) => {
		let { scope: t, children: r, state: a } = e, s = n.useRef(null), [c, l] = n.useState(null), u = m(s, l), [d, f] = a;
		return n.useEffect(() => {
			if (!c) return;
			let e = Ne(() => {});
			return e.observe(c, {
				childList: !0,
				subtree: !0
			}), () => {
				e.disconnect();
			};
		}, [c]), /* @__PURE__ */ i(o, {
			scope: t,
			itemMap: d,
			setItemMap: f,
			collectionRef: u,
			collectionRefObject: s,
			collectionElement: c,
			children: r
		});
	}, "CollectionProviderImpl");
	u.displayName = t + "Impl";
	let d = e + "CollectionSlot", f = /* @__PURE__ */ F(d), p = n.forwardRef((e, t) => {
		let { scope: n, children: r } = e, a = m(t, s(d, n).collectionRef);
		return /* @__PURE__ */ i(f, {
			ref: a,
			children: r
		});
	});
	p.displayName = d;
	let h = e + "CollectionItemSlot", g = /* @__PURE__ */ F(h), _ = n.forwardRef((e, t) => {
		let { scope: r, children: a, ...o } = e, c = n.useRef(null), [l, u] = n.useState(null), d = m(t, c, u), { setItemMap: f } = s(h, r), p = n.useRef(o);
		je(p.current, o) || (p.current = o);
		let _ = p.current;
		return n.useEffect(() => {
			let e = _;
			return f((t) => l ? t.has(l) ? t.set(l, {
				...e,
				element: l
			}).toSorted(U) : (t.set(l, {
				...e,
				element: l
			}), t.toSorted(U)) : t), () => {
				f((e) => !l || !e.has(l) ? e : (e.delete(l), new B(e)));
			};
		}, [
			l,
			_,
			f
		]), /* @__PURE__ */ i(g, {
			"data-radix-collection-item": "",
			ref: d,
			children: a
		});
	});
	_.displayName = h;
	function y() {
		return n.useState(new B());
	}
	z(y, "useInitCollection");
	function b(t) {
		let { itemMap: n } = s(e + "CollectionConsumer", t);
		return n;
	}
	return z(b, "useCollection"), [{
		Provider: c,
		Slot: p,
		ItemSlot: _
	}, {
		createCollectionScope: a,
		useCollection: b,
		useInitCollection: y
	}];
}
z(Ae, "createCollection");
function je(e, t) {
	if (e === t) return !0;
	if (typeof e != "object" || typeof t != "object" || e == null || t == null) return !1;
	let n = Object.keys(e), r = Object.keys(t);
	if (n.length !== r.length) return !1;
	for (let r of n) if (!Object.prototype.hasOwnProperty.call(t, r) || e[r] !== t[r]) return !1;
	return !0;
}
z(je, "shallowEqual");
function Me(e, t) {
	return !!(t.compareDocumentPosition(e) & Node.DOCUMENT_POSITION_PRECEDING);
}
z(Me, "isElementPreceding");
function U(e, t) {
	return !e[1].element || !t[1].element ? 0 : Me(e[1].element, t[1].element) ? -1 : 1;
}
z(U, "sortByDocumentPosition");
function Ne(e) {
	return new MutationObserver((t) => {
		for (let n of t) if (n.type === "childList") {
			e();
			return;
		}
	});
}
z(Ne, "getChildListObserver");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-slider@1.4.5_@types+react-dom@19.2.3_@types+react@19.2.17__@types+react_a0833c54593d661db6c0a4d146ef3a86/node_modules/@radix-ui/react-slider/dist/index.mjs
var Pe = Object.defineProperty, W = (e, t) => Pe(e, "name", {
	value: t,
	configurable: !0
}), Fe = ["PageUp", "PageDown"], Ie = [
	"ArrowUp",
	"ArrowDown",
	"ArrowLeft",
	"ArrowRight"
], Le = {
	"from-left": [
		"Home",
		"PageDown",
		"ArrowDown",
		"ArrowLeft"
	],
	"from-right": [
		"Home",
		"PageDown",
		"ArrowDown",
		"ArrowRight"
	],
	"from-bottom": [
		"Home",
		"PageDown",
		"ArrowDown",
		"ArrowLeft"
	],
	"from-top": [
		"Home",
		"PageDown",
		"ArrowUp",
		"ArrowLeft"
	]
}, G = "Slider", [K, Re, ze] = /* @__PURE__ */ De(G), [q, Be] = /* @__PURE__ */ v(G, [ze]), [Ve, J] = q(G), He = /* @__PURE__ */ n.forwardRef(/* @__PURE__ */ W(function(e, r) {
	let { name: a, min: o = 0, max: s = 100, step: c = 1, orientation: u = "horizontal", disabled: d = !1, minStepsBetweenThumbs: f = 0, preserveThumbOrder: p = !1, defaultValue: h = [o], value: g, onValueChange: _ = /* @__PURE__ */ W(() => {}, "onValueChange"), onValueCommit: v = /* @__PURE__ */ W(() => {}, "onValueCommit"), inverted: y = !1, form: b, ...x } = e, ee = n.useRef(/* @__PURE__ */ new Set()), S = n.useRef(0), C = n.useRef(!1), w = u === "horizontal" ? Ge : Ke, [T, E] = n.useState(null), te = m(r, E), [D = [], O] = ne({
		prop: g,
		defaultProp: h,
		onChange: /* @__PURE__ */ W((e) => {
			[...ee.current][S.current]?.focus({
				preventScroll: !0,
				focusVisible: C.current
			}), C.current = !1, _(e);
		}, "onChange")
	}), k = n.useRef(D), re = n.useRef(D);
	n.useEffect(() => {
		let e = b ? T?.ownerDocument.getElementById(b) : T?.closest("form");
		if (e instanceof HTMLFormElement) {
			let t = /* @__PURE__ */ W(() => O(re.current), "reset");
			return e.addEventListener("reset", t), () => e.removeEventListener("reset", t);
		}
	}, [
		T,
		b,
		O
	]);
	function A(e) {
		N(e, ct(D, e));
	}
	W(A, "handleSlideStart");
	function j(e) {
		N(e, S.current);
	}
	W(j, "handleSlideMove");
	function M() {
		String(D) !== String(k.current) && v(D);
	}
	W(M, "handleSlideEnd");
	function N(e, t, { commit: n } = { commit: !1 }) {
		let r = Q(c), i = l($(Math.round((e - o) / c) * c + o, r), [o, s]);
		O((e = []) => {
			let r = f * c, a = p ? l(i, [e[t - 1] === void 0 ? o : e[t - 1] + r, e[t + 1] === void 0 ? s : e[t + 1] - r]) : i, u = ot(e, a, t);
			if (dt(u, r)) {
				S.current = p ? t : u.indexOf(a);
				let r = String(u) !== String(e);
				return r && n && v(u), r ? u : e;
			} else return e;
		});
	}
	return W(N, "updateValues"), /* @__PURE__ */ i(Ve, {
		scope: e.__scopeSlider,
		name: a,
		disabled: d,
		min: o,
		max: s,
		valueIndexToChangeRef: S,
		thumbs: ee.current,
		values: D,
		orientation: u,
		form: b,
		children: /* @__PURE__ */ i(K.Provider, {
			scope: e.__scopeSlider,
			children: /* @__PURE__ */ i(K.Slot, {
				scope: e.__scopeSlider,
				children: /* @__PURE__ */ i(w, {
					"aria-disabled": d,
					"data-disabled": d ? "" : void 0,
					...x,
					ref: te,
					onPointerDown: t(x.onPointerDown, () => {
						d || (k.current = D, C.current = !1);
					}),
					min: o,
					max: s,
					inverted: y,
					onSlideStart: d ? void 0 : A,
					onSlideMove: d ? void 0 : j,
					onSlideEnd: d ? void 0 : M,
					onHomeKeyDown: () => {
						d || (C.current = !0, N(o, 0, { commit: !0 }));
					},
					onEndKeyDown: () => {
						d || (C.current = !0, N(s, D.length - 1, { commit: !0 }));
					},
					onStepKeyDown: ({ event: e, direction: t }) => {
						if (!d) {
							C.current = !0;
							let n = Fe.includes(e.key) || e.shiftKey && Ie.includes(e.key) ? 10 : 1, r = S.current, i = D[r];
							N(ft(i, {
								min: o,
								step: c,
								direction: t,
								multiplier: n
							}), r, { commit: !0 });
						}
					}
				})
			})
		})
	});
}, "Slider")), [Ue, We] = q(G, {
	startEdge: "left",
	endEdge: "right",
	size: "width",
	direction: 1
}), Ge = /* @__PURE__ */ n.forwardRef(/* @__PURE__ */ W(function(e, t) {
	let { min: r, max: a, dir: o, inverted: s, onSlideStart: c, onSlideMove: l, onSlideEnd: u, onStepKeyDown: d, ...f } = e, [p, h] = n.useState(null), g = m(t, h), _ = n.useRef(void 0), v = N(o), y = v === "ltr", b = y && !s || !y && s;
	function x(e) {
		let t = _.current || p.getBoundingClientRect(), n = Z([0, t.width], b ? [r, a] : [a, r]);
		return _.current = t, n(e - t.left);
	}
	return W(x, "getValueFromPointer"), /* @__PURE__ */ i(Ue, {
		scope: e.__scopeSlider,
		startEdge: b ? "left" : "right",
		endEdge: b ? "right" : "left",
		direction: b ? 1 : -1,
		size: "width",
		children: /* @__PURE__ */ i(qe, {
			dir: v,
			"data-orientation": "horizontal",
			...f,
			ref: g,
			style: {
				...f.style,
				"--radix-slider-thumb-transform": "translateX(-50%)"
			},
			onSlideStart: (e) => {
				let t = x(e.clientX);
				c?.(t);
			},
			onSlideMove: (e) => {
				let t = x(e.clientX);
				l?.(t);
			},
			onSlideEnd: () => {
				_.current = void 0, u?.();
			},
			onStepKeyDown: (e) => {
				let t = Le[b ? "from-left" : "from-right"].includes(e.key);
				d?.({
					event: e,
					direction: t ? -1 : 1
				});
			}
		})
	});
}, "SliderHorizontal")), Ke = /* @__PURE__ */ n.forwardRef(/* @__PURE__ */ W(function(e, t) {
	let { min: r, max: a, inverted: o, onSlideStart: s, onSlideMove: c, onSlideEnd: l, onStepKeyDown: u, ...d } = e, f = n.useRef(null), p = m(t, f), h = n.useRef(void 0), g = !o;
	function _(e) {
		let t = h.current || f.current.getBoundingClientRect(), n = Z([0, t.height], g ? [a, r] : [r, a]);
		return h.current = t, n(e - t.top);
	}
	return W(_, "getValueFromPointer"), /* @__PURE__ */ i(Ue, {
		scope: e.__scopeSlider,
		startEdge: g ? "bottom" : "top",
		endEdge: g ? "top" : "bottom",
		size: "height",
		direction: g ? 1 : -1,
		children: /* @__PURE__ */ i(qe, {
			"data-orientation": "vertical",
			...d,
			ref: p,
			style: {
				...d.style,
				"--radix-slider-thumb-transform": "translateY(50%)"
			},
			onSlideStart: (e) => {
				let t = _(e.clientY);
				s?.(t);
			},
			onSlideMove: (e) => {
				let t = _(e.clientY);
				c?.(t);
			},
			onSlideEnd: () => {
				h.current = void 0, l?.();
			},
			onStepKeyDown: (e) => {
				let t = Le[g ? "from-bottom" : "from-top"].includes(e.key);
				u?.({
					event: e,
					direction: t ? -1 : 1
				});
			}
		})
	});
}, "SliderVertical")), qe = /* @__PURE__ */ n.forwardRef(/* @__PURE__ */ W(function(e, n) {
	let { __scopeSlider: r, onSlideStart: a, onSlideMove: o, onSlideEnd: s, onHomeKeyDown: c, onEndKeyDown: l, onStepKeyDown: u, ...d } = e, f = J(G, r);
	return /* @__PURE__ */ i(R.span, {
		...d,
		ref: n,
		onKeyDown: t(e.onKeyDown, (e) => {
			e.key === "Home" ? (c(e), e.preventDefault()) : e.key === "End" ? (l(e), e.preventDefault()) : Fe.concat(Ie).includes(e.key) && (u(e), e.preventDefault());
		}),
		onPointerDown: t(e.onPointerDown, (e) => {
			let t = e.target;
			t.setPointerCapture(e.pointerId), e.preventDefault(), f.thumbs.has(t) ? t.focus({
				preventScroll: !0,
				focusVisible: !1
			}) : a(e);
		}),
		onPointerMove: t(e.onPointerMove, (e) => {
			e.target.hasPointerCapture(e.pointerId) && o(e);
		}),
		onPointerUp: t(e.onPointerUp, (e) => {
			let t = e.target;
			t.hasPointerCapture(e.pointerId) && (t.releasePointerCapture(e.pointerId), s(e));
		})
	});
}, "SliderImpl")), Je = "SliderTrack", Ye = /* @__PURE__ */ n.forwardRef(/* @__PURE__ */ W(function(e, t) {
	let { __scopeSlider: n, ...r } = e, a = J(Je, n);
	return /* @__PURE__ */ i(R.span, {
		"data-disabled": a.disabled ? "" : void 0,
		"data-orientation": a.orientation,
		...r,
		ref: t
	});
}, "SliderTrack")), Xe = "SliderRange", Ze = /* @__PURE__ */ n.forwardRef(/* @__PURE__ */ W(function(e, t) {
	let { __scopeSlider: r, ...a } = e, o = J(Xe, r), s = We(Xe, r), c = m(t, n.useRef(null)), l = o.values.length, u = o.values.map((e) => X(e, o.min, o.max)), d = l > 1 ? Math.min(...u) : 0, f = 100 - Math.max(...u);
	return /* @__PURE__ */ i(R.span, {
		"data-orientation": o.orientation,
		"data-disabled": o.disabled ? "" : void 0,
		...a,
		ref: c,
		style: {
			...e.style,
			[s.startEdge]: d + "%",
			[s.endEdge]: f + "%"
		}
	});
}, "SliderRange")), [Qe, $e] = q("SliderThumb"), et = "SliderThumbProvider";
function tt(e) {
	let { __scopeSlider: t, name: r, children: a, internal_do_not_use_render: o } = e, s = J(et, t), c = Re(t), [l, u] = n.useState(null), d = n.useMemo(() => l ? c().findIndex((e) => e.ref.current === l) : -1, [c, l]), f = le(l), p = !l || !!s.form || !!l.closest("form"), m = s.values[d], h = r ?? (s.name ? s.name + (s.values.length > 1 ? "[]" : "") : void 0), g = m === void 0 ? 0 : X(m, s.min, s.max);
	n.useEffect(() => {
		if (l) return s.thumbs.add(l), () => {
			s.thumbs.delete(l);
		};
	}, [l, s.thumbs]);
	let _ = {
		value: m,
		name: h,
		form: s.form,
		isFormControl: p,
		index: d,
		thumb: l,
		onThumbChange: u,
		percent: g,
		size: f
	};
	return /* @__PURE__ */ i(Qe, {
		scope: t,
		..._,
		children: pt(o) ? o(_) : a
	});
}
W(tt, "SliderThumbProvider");
var Y = "SliderThumbTrigger", nt = /* @__PURE__ */ n.forwardRef(/* @__PURE__ */ W(function(e, n) {
	let { __scopeSlider: r, ...a } = e, o = J(Y, r), s = We(Y, r), { index: c, value: l, percent: u, size: d, onThumbChange: f } = $e(Y, r), p = m(n, f), h = st(c, o.values.length), g = d?.[s.size], _ = g ? lt(g, u, s.direction) : 0;
	return /* @__PURE__ */ i("span", {
		style: {
			transform: "var(--radix-slider-thumb-transform)",
			position: "absolute",
			[s.startEdge]: `calc(${u}% + ${_}px)`
		},
		children: /* @__PURE__ */ i(K.ItemSlot, {
			scope: r,
			children: /* @__PURE__ */ i(R.span, {
				role: "slider",
				"aria-label": e["aria-label"] || h,
				"aria-valuemin": o.min,
				"aria-valuenow": l,
				"aria-valuemax": o.max,
				"aria-orientation": o.orientation,
				"data-orientation": o.orientation,
				"data-disabled": o.disabled ? "" : void 0,
				tabIndex: o.disabled ? void 0 : 0,
				...a,
				ref: p,
				style: l === void 0 ? { display: "none" } : e.style,
				onFocus: t(e.onFocus, () => {
					o.valueIndexToChangeRef.current = c;
				})
			})
		})
	});
}, "SliderThumbTrigger")), rt = /* @__PURE__ */ n.forwardRef(/* @__PURE__ */ W(function(e, t) {
	let { __scopeSlider: n, name: o, ...s } = e;
	return /* @__PURE__ */ i(tt, {
		__scopeSlider: n,
		name: o,
		internal_do_not_use_render: ({ index: e, isFormControl: o }) => /* @__PURE__ */ a(r, { children: [/* @__PURE__ */ i(nt, {
			...s,
			ref: t,
			__scopeSlider: n
		}), o ? /* @__PURE__ */ i(at, { __scopeSlider: n }, e) : null] })
	});
}, "SliderThumb")), it = "SliderBubbleInput", at = /* @__PURE__ */ n.forwardRef(/* @__PURE__ */ W(function({ __scopeSlider: e, ...t }, r) {
	let { value: a, name: o, form: s } = $e(it, e), c = n.useRef(null), l = m(c, r), u = oe(a);
	return n.useEffect(() => {
		let e = c.current;
		if (!e) return;
		let t = window.HTMLInputElement.prototype, n = Object.getOwnPropertyDescriptor(t, "value").set;
		if (u !== a && n) {
			let t = new Event("input", { bubbles: !0 });
			n.call(e, a), e.dispatchEvent(t);
		}
	}, [u, a]), /* @__PURE__ */ i(R.input, {
		style: { display: "none" },
		name: o,
		form: s,
		...t,
		ref: l,
		defaultValue: a
	});
}, "SliderBubbleInput"));
function ot(e = [], t, n) {
	let r = [...e];
	return r[n] = t, r.sort((e, t) => e - t);
}
W(ot, "getNextSortedValues");
function X(e, t, n) {
	return l(100 / (n - t) * (e - t), [0, 100]);
}
W(X, "convertValueToPercentage");
function st(e, t) {
	if (t > 2) return `Value ${e + 1} of ${t}`;
	if (t === 2) return ["Minimum", "Maximum"][e];
}
W(st, "getLabel");
function ct(e, t) {
	if (e.length === 1) return 0;
	let n = e.map((e) => Math.abs(e - t)), r = Math.min(...n);
	return n.indexOf(r);
}
W(ct, "getClosestValueIndex");
function lt(e, t, n) {
	let r = e / 2;
	return (r - Z([0, 50], [0, r])(t) * n) * n;
}
W(lt, "getThumbInBoundsOffset");
function ut(e) {
	return e.slice(0, -1).map((t, n) => e[n + 1] - t);
}
W(ut, "getStepsBetweenValues");
function dt(e, t) {
	if (t > 0) {
		let n = ut(e);
		return Math.min(...n) >= t;
	}
	return !0;
}
W(dt, "hasMinStepsBetweenValues");
function Z(e, t) {
	return (n) => {
		if (e[0] === e[1] || t[0] === t[1]) return t[0];
		let r = (t[1] - t[0]) / (e[1] - e[0]);
		return t[0] + r * (n - e[0]);
	};
}
W(Z, "linearScale");
function Q(e) {
	if (!Number.isFinite(e)) return 0;
	let t = e.toString();
	if (t.includes("e")) {
		let [e, n] = t.split("e"), r = e.split(".")[1] || "", i = Number(n);
		return Math.max(0, r.length - i);
	}
	let n = t.split(".")[1];
	return n ? n.length : 0;
}
W(Q, "getDecimalCount");
function $(e, t) {
	let n = 10 ** t;
	return Math.round(e * n) / n;
}
W($, "roundValue");
function ft(e, { min: t, step: n, direction: r, multiplier: i }) {
	let a = Q(n), o = (e - t) / n, s = Math.round(o), c = $(s * n + t, a) === $(e, a), l;
	return l = c ? s + i * r : r > 0 ? Math.ceil(o) : Math.floor(o), $(l * n + t, a);
}
W(ft, "getNextStepValue");
function pt(e) {
	return typeof e == "function";
}
W(pt, "isFunction");
//#endregion
//#region src/foundations/slider/slider.tsx
var mt = n.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ a(He, {
	className: e("relative flex w-full touch-none select-none items-center data-[disabled]:opacity-50", t),
	...n,
	ref: r,
	children: [/* @__PURE__ */ i(Ye, {
		className: "bg-secondary relative h-1.5 w-full grow overflow-hidden rounded-full",
		children: /* @__PURE__ */ i(Ze, { className: "bg-primary absolute h-full" })
	}), /* @__PURE__ */ i(rt, {
		"aria-label": n["aria-label"],
		className: "border-primary/50 bg-background focus-visible:ring-ring focus-visible:ring-offset-background block h-4 w-4 rounded-full border shadow-sm transition-colors focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50"
	})]
}));
mt.displayName = He.displayName;
//#endregion
export { mt as t };

//# sourceMappingURL=slider-D1_BcUlF.js.map